var t = require('i18n').t

Billy.DaybookTransaction.reopen({
    humanType: function() {
        var type = this.get('type')
        return type ? t('daybook_transaction.type.' + Em.String.underscore(type)) : null
    }.property('type')
})
